import { render, staticRenderFns } from "./KnowledgeTest.vue?vue&type=template&id=7c8ceba6&"
import script from "./KnowledgeTest.vue?vue&type=script&lang=js&"
export * from "./KnowledgeTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports